import React, { useEffect, useState } from "react";
import moment from "moment";
import MonthSelect from "../components/timesheets/MonthSelect";
import Container from "../components/library/Container";
import { Redirect } from "react-router-dom";
import Table from "../components/team/Table";
import { encodeDateURI, formatDate } from "../inc/helpers/date";

function Team() {
  const [selectedMonth, setSelectedMonth] = useState(moment().startOf("month"));
  const [team, setTeam] = useState(null);

  const monthWithExtraWeek = moment(selectedMonth).subtract(7, "d");

  const fetchTeam = async () => {
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_ENDPOINT
        }/api/team?startMonth=${encodeDateURI(
          monthWithExtraWeek
        )}&endMonth=${encodeDateURI(moment(selectedMonth).endOf("month"))}`,
        {
          headers: {
            "x-access-token": localStorage.getItem("access_token"),
          },
        }
      );

      const newTeam = await response.json();

      const summedTimeTeam = newTeam.map((member) => ({
        ...member,
        time: member.time.reduce(
          (prev, curr) =>
            prev[formatDate(curr.date)]
              ? {
                  ...prev,
                  [formatDate(curr.date)]:
                    prev[formatDate(curr.date)] + curr.minutes,
                }
              : { ...prev, [formatDate(curr.date)]: curr.minutes },
          {}
        ),
      }));

      setTeam(summedTimeTeam);
    } catch (err) {
      setTeam([]);
      console.error(err);
    }
  };

  useEffect(() => {
    fetchTeam();
  }, [selectedMonth]);

  return (
    <Container
      style={{
        flexGrow: 1,
        background: "var(--grey-110-color)",
        paddingTop: "1rem",
      }}
    >
      {team && team.length === 0 && <Redirect to="/" />}
      <div
        style={{
          marginLeft: "auto",
          width: 280,
          marginBottom: "1rem",
          padding: "0.5rem",
          backgroundColor: "var(--grey-95-color)",
          borderRadius: 4,
        }}
      >
        <MonthSelect
          date={selectedMonth}
          onDateSelect={(newDate) =>
            setSelectedMonth(moment(newDate).format("YYYY-MM-01 00:00:00"))
          }
        />
      </div>
      <Table team={team} selectedMonth={selectedMonth} />
    </Container>
  );
}

export default Team;
